import { Component } from '@angular/core';

@Component({
  selector: 'gf-spinner',
  template: '<img style="display: block; margin: auto; max-width: 64px; width: 100%;" src="/core/img/ajax-loader.svg" />',
})
export class SpinnerComponent {
  constructor() {}
}
